export default __webpack_public_path__ + "static/media/armo.ee3c9ef9.svg";